export default __webpack_public_path__ + "static/media/fluffy-cloud.87028225.png";